module.exports = __webpack_public_path__ + "static/media/Air Greenland_2026_Logo.a7c14985.png";